import { htmlToSlate, slateToHtml } from '@slate-serializers/html';
import { htmlToSlateConfig } from '../config/htmlToSlateConfig.js';
import { slateToHtmlConfig } from '../config/slateToHtmlConfig.js';
import { Transforms } from 'slate';
import { applyRulesToHtml } from './html-format-rules.js';
import { splitOnBlockElements } from './index.js';
import { encode } from 'js-base64';
import DOMPurify from 'dompurify';
import { Types } from './contants.js';

var htmlToSlateJson = function htmlToSlateJson(editor) {
  var serialized = contentToSlate(editor.string([]));
  Transforms.insertNodes(editor, {
    type: 'paragraph',
    children: [{
      text: ''
    }]
  });
  return serialized;
};

var contentToSlate = function contentToSlate(content) {
  return htmlToSlate(applyRulesToHtml(content), htmlToSlateConfig);
};

var jsonToSlateHtml = function jsonToSlateHtml(editor) {
  var serialized = jsonToHtml(editor);

  var toChildren = function toChildren(content) {
    return [{
      text: content
    }];
  };

  var toCodeLines = function toCodeLines(content) {
    var lines = splitOnBlockElements(content);
    return lines.map(function (line) {
      return {
        type: Types.codeLine,
        children: toChildren(line)
      };
    });
  };

  return [{
    type: Types.codeBlock,
    language: 'html',
    children: toCodeLines(serialized)
  }];
}; // just the html


var jsonToHtml = function jsonToHtml(editor) {
  return slateToHtml(editor.children, slateToHtmlConfig);
};

var sanitizeWithRules = function sanitizeWithRules(data) {
  return DOMPurify.sanitize(data, {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['target', 'allow', 'allowfullscreen', 'frameborder', 'scrolling']
  });
};

var sanitizeHtml = function sanitizeHtml(data) {
  return encode(sanitizeWithRules(data));
};

export { contentToSlate, htmlToSlateJson, jsonToHtml, jsonToSlateHtml, sanitizeHtml, sanitizeWithRules };